class TreatmentUspCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    if (this.dataset.slideCount < 2) return

    const next = this.els.next?.element
    const previous = this.els.previous?.element

    const plugins = [
      window.BAO.Carousel.useInitialised(),
      window.BAO.Carousel.useAutoplay(2, { pauseOnHover: true }),
    ]

    if (next && previous) {
      plugins.push(window.BAO.Carousel.useArrows({ next, previous }))
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          disabled: Number(this.dataset.slideCount) < 1,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xlg}px)`]: {
            slides: {
              perView: 2,
              disabled: Number(this.dataset.slideCount) < 2,
            },
          },
        },
      },
      plugins,
    )
  }
}

if (!customElements.get('treatment-usp-carousel')) {
  customElements.define('treatment-usp-carousel', TreatmentUspCarousel)
}
